import React, { useState, useEffect } from 'react';
import { Nav, NavItem } from "reactstrap";
import { useNavigate } from "react-router-dom"
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import "./SideBar.css";
import { DocumentFilterList } from "components/menu/Labels";
import {
    IDocumentFilter, IDocumentModule, IDocumentSubType, RulebookDocumentMenuCBTC, RulebookDocumentMenuTraditional,
    RailRulebookDocumentModuleTraditional, RailRulebookDocumentModuleCBTC
} from 'components/ui/DocumentRules';
import { RulebookModeEnum, RulebookNameToEnum } from '../../../shared/enums/rulebook-mode-enum';
import { getUserExistingRulebookMode } from '../../../shared/store/applicationState';

interface IRailRulebookMenuProps {
    documentId: number,
    typeId: number,
    subTypeId: number | null,
    isExpanded: boolean,
    setIsExpanded: (value: boolean) => void

}

const PopulatedRailRulebookMenu = (props: IRailRulebookMenuProps) => {
    const [activeFilter, setActiveFilter] = useState(null as IDocumentFilter | null);
    const [activeSubFilter, setActiveSubFilter] = useState(null as IDocumentFilter | null);

    const mode = getUserExistingRulebookMode();
    const navigate = useNavigate();

    const navigateToDocument = (id: number) => {
        navigate(`/pdf/view/${mode}/` + id);
        props.setIsExpanded(false);
    }

    let Icon, RulebookDocumentMenu: IDocumentModule = {} as IDocumentModule;
    if (RulebookNameToEnum(mode) === RulebookModeEnum.Traditional) {
        Icon = RailRulebookDocumentModuleTraditional.icon;
        RulebookDocumentMenu = RulebookDocumentMenuTraditional;
    } else if (RulebookNameToEnum(mode) === RulebookModeEnum.CBTC) {
        RulebookDocumentMenu = RulebookDocumentMenuCBTC;
        Icon = RailRulebookDocumentModuleCBTC.icon;
    } else {
        Icon = undefined;
        RulebookDocumentMenu = {} as IDocumentModule;
        console.log('TOC Error: RulebookDocumentMenu undefined - document mode is not set');
    }

    useEffect(() => {
        RulebookDocumentMenu.filters.forEach(f => {
            f.subFilters?.forEach(sf => {
                if ((sf as IDocumentSubType).id === props.subTypeId) {
                    setActiveSubFilter(sf);
                    return;
                }

                if ((sf as IDocumentSubType).id === props.typeId) {
                    setActiveSubFilter(sf);
                    setActiveFilter(f);
                    return;
                }
            });

            if ((f as IDocumentSubType).id === props.typeId) {
                setActiveFilter(f);
                return;
            }
        });
    }, []);

    return (
        <Nav className="toc-menu col d-block sidebar">
            <NavItem tag="div" className="toc-header">
                <div className="icon">
                    <Icon />
                </div>
                <div className="label">Rulebook</div>
            </NavItem>
            <NavItem>
                <h3 className="toc-contents-label">Contents</h3>
                <DocumentFilterList
                    view={RulebookDocumentMenu}
                    onDocumentClick={doc => navigateToDocument(doc.id)}
                    hideSubFilters={false}
                    selectedDocumentId={props.documentId}
                    activeFilter={activeFilter}
                    setActiveFilter={setActiveFilter}
                    activeSubFilter={activeSubFilter}
                    setActiveSubFilter={setActiveSubFilter} />
            </NavItem>
        </Nav>
    );
}


const SideBar = (props: { docId: string, typeId: number, subTypeId: number | null }) => {
    const [shown, setShown] = useState(false);

    const toggleShown = () => {
        setShown(!shown);
    }

    const isTocEnabled = () => {
        //Only show Rulebook module or OperatingNotices/OperatingInstructions from Documents module, these are typeId 1 to 300
        if (props.typeId < 301) {
            return true;
        }

        //All document type ids above 300 is in the Document module and is no an ON/OI and should not be shown
        return false;
    }

    return (
        <>
            {isTocEnabled() &&
                <>
                    <div className="toc-trigger toc-trigger-main" onClick={toggleShown}>
                        <ChevronRight fontSize="large" />
                        <span>Rulebook</span>
                    </div>

                    <div className={`toc-screen` + `${shown ? " toc-screen-show" : ""}`}>
                        <div className="toc-screen-bg" onClick={toggleShown}></div>
                        <div className="toc-container">
                            <div className="toc-trigger toc-trigger-expanded" onClick={toggleShown}>
                                <ChevronLeft fontSize="large" />
                            </div>
                            <div className="toc-container-pad">
                                <PopulatedRailRulebookMenu
                                    typeId={props.typeId}
                                    subTypeId={props.subTypeId}
                                    documentId={parseInt(props.docId)}
                                    isExpanded={shown}
                                    setIsExpanded={setShown}
                                />
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    );

}

export default SideBar;
